export const REGISTRATIONS_RESET = 'REGISTRATIONS_RESET';
